export default __webpack_public_path__ + "static/media/hermes.0f351ccf.png";